/**
 * Maktab ADMINI (DIRECTOR/ADMIN) paroli — backend `lib/validate.ts` →
 * TENANT_ADMIN_PASSWORD_MIN bilan bir xil. Superadmin yangi maktab yaratganda va
 * admin parolini qayta o'rnatganda qo'llanadi.
 */
export const TENANT_ADMIN_PASSWORD_MIN = 8;

/** Login quyi chegarasi — backend `LOGIN_MIN` (xodim, ota-ona formalari bilan bir xil). */
export const LOGIN_MIN = 3;

/** F.I.Sh. chegaralari — backend `lib/validate.ts` → normalizeFullName bilan bir xil. */
export const FULL_NAME_MIN = 2;
export const FULL_NAME_MAX = 100;

/** Backend bilan bir xil tozalash: har qanday bo'shliq bitta oddiy bo'shliq, chetlari kesiladi. */
export const cleanFullName = (v: string): string =>
  v.replace(/[​-‍⁠﻿]/g, '').replace(/\s+/g, ' ').trim(); // nol-kenglikli belgilar ham (backend kabi)

/**
 * F.I.Sh. xatosi (`settings.*` i18n kaliti) yoki `null`. Profil tahriri va superadmin
 * "Admin qo'shish" formasi — BITTA qoida (backend `normalizeFullName` ning aksi).
 */
export function fullNameError(v: string): 'nameMin' | 'nameMax' | 'nameLetters' | null {
  const n = Array.from(cleanFullName(v));
  if (n.length < FULL_NAME_MIN) return 'nameMin';
  if (n.length > FULL_NAME_MAX) return 'nameMax';
  if (!/\p{L}/u.test(n.join(''))) return 'nameLetters';
  return null;
}

// Ko'z bilan adashtiriladigan belgilarsiz (0/O, 1/l/I) — parol og'zaki yoki qog'ozda
// uzatilganda xato terilmasin.
const LOWER = 'abcdefghijkmnpqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGIT = '23456789';
const SYMBOL = '!@#$%*-_+=?';

/** Kriptografik tasodifiy butun son [0, n) — modul siljishisiz (rejection sampling). */
function randInt(n: number): number {
  const limit = Math.floor(4294967296 / n) * n; // 2^32 — Uint32 qiymatlar soni
  const buf = new Uint32Array(1);
  for (;;) {
    crypto.getRandomValues(buf);
    if (buf[0] < limit) return buf[0] % n;
  }
}

/**
 * Kuchli parol yaratish (brauzerda, `crypto.getRandomValues`): har turdan kamida
 * bittadan belgi (kichik, katta, raqam, belgi), qolgani umumiy to'plamdan, so'ng
 * aralashtiriladi. Parol serverga faqat saqlashda yuboriladi.
 */
export function generateStrongPassword(length = 14): string {
  const len = Math.max(TENANT_ADMIN_PASSWORD_MIN, length);
  const all = LOWER + UPPER + DIGIT + SYMBOL;
  const chars = [LOWER, UPPER, DIGIT, SYMBOL].map((set) => set[randInt(set.length)]);
  while (chars.length < len) chars.push(all[randInt(all.length)]);
  // Fisher–Yates — majburiy belgilar doim boshida turmasin
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}
